export default __webpack_public_path__ + "static/media/0xad5dc12e88c6534eea8cfe2265851d9d4a1472ad.12722290.png";